import { render } from "./toB.vue?vue&type=template&id=75023236&scoped=true"
import script from "./toB.vue?vue&type=script&lang=js"
export * from "./toB.vue?vue&type=script&lang=js"

import "./toB.vue?vue&type=style&index=0&id=75023236&lang=scss&scoped=true"
import "./toB.vue?vue&type=style&index=1&id=75023236&lang=scss"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75023236"]])

export default __exports__